'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import './QuestionsAnswers.css';
import '../ToolDetailsPage.css';
import '../../tools/ToolsPage.css';
import '../all-questions/QuestionsAnswers.css';

import { IoMdCheckmarkCircle } from 'react-icons/io';
import { MdKeyboardArrowRight } from 'react-icons/md';

import content from '../../../config/germanTestContent.json';
import strings from '../../../config/App.json';

import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import { SideAds } from '../../../components/Ads/Ads';
import QuestionsPlaceholder from '@/components/Placeholder/QuestionsPlaceholder';
import ImageComponent from '@/app/tools/component/ImageComponent';
import Pagination from '@/components/Pagination/Pagination';

const PER_PAGE = 5;

const QuestionsAnswers = ({ initialQuestions = [] }) => {
  const router = useRouter();

  const [questionsData, setQuestionsData] = useState(initialQuestions);
  const [currentPage, setCurrentPage] = useState(1);

  const loading = questionsData.length === 0;
  const totalPages = Math.ceil(questionsData.length / PER_PAGE);

  const paginatedData = questionsData.slice(
    (currentPage - 1) * PER_PAGE,
    currentPage * PER_PAGE
  );

  useEffect(() => {
    if (!initialQuestions.length) {
      const stored = localStorage.getItem("questionsData");
      if (stored) {
        try {
          setQuestionsData(JSON.parse(stored));
        } catch (e) {
          console.error("LocalStorage parse error", e);
        }
      }
    }
  }, [initialQuestions.length]);

  useEffect(() => {
    if (questionsData.length) {
      localStorage.setItem("questionsData", JSON.stringify(questionsData));
    }
  }, [questionsData]);

  useEffect(() => {
    window.scrollTo({ top: 150, behavior: "smooth" });
  }, [currentPage]);

  return (
    <>
      <Header />

      <div className="tools-container">
        <div className="german-test-header">
          <button
            className="Home-button"
            onClick={() => router.push(strings.HomePage)}
          >
            <img
              src="/images/Tools/homeIcon.svg"
              alt="Home"
              className="home-icon"
            />
          </button>

          <MdKeyboardArrowRight className="home-icon" />

          <button
            className="Home-button"
            onClick={() => router.push(strings.ToolDetailsPage)}
          >
            <span className="Home-text_ttl">
              {content.breadcrumb.pageTitle}
            </span>
          </button>

          <MdKeyboardArrowRight className="home-icon" />

          <span className="Home-text_ger">
            {loading ? "Loading..." : `${questionsData.length} Questions`}
          </span>
        </div>

        <div className="german-test-content-container">
          <div className="german-test-content">
            {loading ? (
              <>
                <h2 className="qa-title">Loading Questions...</h2>
                <QuestionsPlaceholder />
              </>
            ) : (
              <>
                <h2 className="qa-title">
                  {questionsData.length} Questions
                </h2>

                {paginatedData.map((q, index) => {
                  let options = {};
                  try {
                    options =
                      typeof q.options === "string"
                        ? JSON.parse(q.options)
                        : q.options;
                  } catch {
                    options = {};
                  }

                  const correctKey = q?.Answer?.answers;

                  return (
                    <div key={q.id} className="question-card">
                      <div className="question-header">
                        <span className="question-number">
                          Q{(currentPage - 1) * PER_PAGE + index + 1}
                        </span>
                        <span className="question-text">{q.question}</span>
                      </div>

                      {q.image && (
                        <div className="QuestionImage">
                          <ImageComponent imagePath={q.image} />
                        </div>
                      )}

                      <div className="options-list">
                        {Object.entries(options).map(([key, value]) => (
                          <label
                            key={key}
                            className={`option-item ${key === correctKey ? "correct" : ""
                              }`}
                          >
                            <input
                              type="radio"
                              checked={key === correctKey}
                              readOnly
                            />
                            <span>{value}</span>
                            {key === correctKey && (
                              <IoMdCheckmarkCircle className="check-icon" />
                            )}
                          </label>
                        ))}
                      </div>
                    </div>
                  );
                })}

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </>
            )}
          </div>

          <div className="tools-advertisement">
            <SideAds />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default QuestionsAnswers;
